module.exports = __webpack_public_path__ + "media/images/icon_chevron-left-019322db8384847fe22ab20e64ee6ebc.svg";